import React from 'react';
import cn from 'classnames';
import { Spinner } from 'src/components/animations/Spinner';

const baseCls = 'lt-preloader';

interface Props {
  className?: string;
  throbber?: boolean;
}

/**
 * Компонент для отображения прелоадера
 * если передан `throbber`, отображается спиннер
 * или выводится анимированный лоадер ЛТ с солнцем
 */
export const Preloader = (props: Props) => {
  const { className, throbber } = props;

  if (throbber) {
    return <Spinner className={className} />;
  }

  return (
    <div className={cn(`${baseCls}-logo`, className)}>
      <div className={`${baseCls}-logo__sun-mask`}>
        <div className={`${baseCls}-logo__sun`} />
      </div>
      <div className={`${baseCls}-logo__wave`} />
      <div className={`${baseCls}-logo__wave__2`} />
      <div className={`${baseCls}-logo__wave__3`} />
    </div>
  );
};
